import apiClient from '@/services/api'
import { prepareFilterWithEmployeeLegalEntities } from '@/utils/payment-type-legal-entity-filter'

const assertNoApiError = data => {
  if (data.error_code && data.error_code !== '0') {
    throw new Error(`${data.msg}`)
  }
}

export default {
  async getActiveAssociatesReport(_, { associate_number, date_from, date_to }) {
    const { data } = await apiClient.post('/api/tc_get_active_associates_report', {
      associate_number,
      date_from,
      date_to
    })

    return data
  },

  async getTimeAttendanceDetailReportLegacy(
    _,
    {
      associateNumbers,
      dateFrom,
      dateTo,
      role,
      status,
      headerContentOptions,
      reportContentOptions,
      ids,
      groupBy,
      divideByDays,
      withoutPayCodes,
      agency,
      departments,
      paymentTypes
    }
  ) {
    const { data } = await apiClient.post('/api/tc_get_time_attendance_detail_report', {
      associate_ids: associateNumbers,
      date_from: dateFrom,
      date_to: dateTo,
      role_ids: role,
      status,
      header_content_options: headerContentOptions,
      report_content_options: reportContentOptions,
      ids,
      group_by: groupBy,
      divide_by_days: divideByDays,
      without_pay_codes: withoutPayCodes,
      legal_entity_ids: agency,
      departments_ids: departments,
      payment_type: paymentTypes
    })

    return data
  },

  async sendShiftsReport(
    _,
    {
      associateNumber,
      dateFrom,
      dateTo,
      groupBy,
      role,
      status,
      headerContentOptions,
      reportContentOptions,
      divideByDays,
      withoutPayCodes,
      agency,
      departments,
      paymentTypes
    }
  ) {
    const { data } = await apiClient.post('/api/tc_send_shifts_report', {
      associate_ids: associateNumber,
      start: dateFrom,
      end: dateTo,
      group_by: groupBy,
      role_ids: role,
      status,
      header_content_options: headerContentOptions,
      report_content_options: reportContentOptions,
      divide_by_days: divideByDays,
      without_pay_codes: withoutPayCodes,
      legal_entity_ids: agency,
      departments_ids: departments,
      payment_type: paymentTypes
    })

    return data
  },

  async getGeneralDailyReport({ rootState }, { date, filters }) {
    const ptName = rootState.applicationState.currentPaymentTypeName
    const paymentType = ptName && ptName.toLowerCase() !== 'all' ? ptName.toLowerCase() : undefined
    const { data } = await apiClient.post('/api/report/project/general/daily/get', {
      project_id: rootState.applicationState.currentProject.id,
      date,
      filter: {
        manager_scopes: rootState.applicationState.associate.manager_scopes,
        associates: filters.associates,
        role: filters.role,
        payment_type: paymentType,
        legal_entity: filters.legalEntity,
        shift_status: filters.shiftStatus,
        shift_payment_status: filters.shiftPaymentStatus
      }
    })

    return data
  },

  // async downloadTimeAttendance(
  //   { commit, rootState },
  //   { start_date, end_date, report_type = "timesheet" }
  // ) {
  //   const { currentProject } = rootState.applicationState;

  //   try {
  //     const { data } = await apiClient.post(
  //       `/api/project/report/time_attendance/get`,
  //       {
  //         project_id: currentProject.id,
  //         start_date,
  //         end_date,
  //         report_type,
  //         device_id: "9afbdd2824fc7073",
  //       }
  //     );

  //     if (data.error_code && data.error_code !== "0") {
  //       throw new Error("Please try again later");
  //     }
  //   } catch (error) {
  //     throw error.message;
  //   }
  // },

  // async sendTimeAttendance(
  //   { commit, rootState },
  //   { email, start_date, end_date, report_type = "timesheet" }
  // ) {
  //   const { currentProject } = rootState.applicationState;

  //   try {
  //     const { data } = await apiClient.post(
  //       `/api/project/report/time_attendance/send_email`,
  //       {
  //         project_id: currentProject.id,
  //         email,
  //         start_date,
  //         end_date,
  //         report_type,
  //       }
  //     );

  //     if (data.error_code && data.error_code !== "0") {
  //       throw new Error("Please try again later");
  //     }
  //   } catch (error) {
  //     throw error.message;
  //   }
  // },

  async downloadShiftCards({ rootState }, { filters }) {
    const { currentProject, currentPaymentTypeName } = rootState.applicationState
    const paymentType = currentPaymentTypeName !== 'All' ? currentPaymentTypeName : filters.payment_type
    const normalizedFilters = prepareFilterWithEmployeeLegalEntities({
      filter: filters,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_ids',
      paymentTypes: paymentType
    })

    try {
      const { data } = await apiClient.get(`/api/report/project/${currentProject.id}/shift_card/download`, {
        params: {
          ...normalizedFilters,
          ...(currentPaymentTypeName !== 'All' && {
            payment_type: currentPaymentTypeName
          })
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async sendShiftCards({ rootState }, { email, filters }) {
    const { currentProject, currentPaymentTypeName } = rootState.applicationState
    const paymentType = currentPaymentTypeName !== 'All' ? currentPaymentTypeName : filters.payment_type
    const normalizedFilters = prepareFilterWithEmployeeLegalEntities({
      filter: filters,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_ids',
      paymentTypes: paymentType
    })

    try {
      const { data } = await apiClient.get(`/api/report/project/${currentProject.id}/shift_card/send_email/${email}`, {
        params: {
          ...normalizedFilters,
          ...(currentPaymentTypeName !== 'All' && {
            payment_type: currentPaymentTypeName
          })
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async downloadExternalSystem({ rootState }, { start, end, ...params }) {
    const { currentProject } = rootState.applicationState
    const normalizedParams = prepareFilterWithEmployeeLegalEntities({
      filter: params,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_ids'
    })

    try {
      const { data } = await apiClient.get(
        `/api/report/project/${currentProject.id}/external_system/${start}/${end}/download`,
        { params: normalizedParams }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async sendExternalSystem({ rootState }, { start, end, email, ...params }) {
    const { currentProject } = rootState.applicationState
    const normalizedParams = prepareFilterWithEmployeeLegalEntities({
      filter: params,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_ids'
    })

    try {
      const { data } = await apiClient.get(
        `/api/report/project/${currentProject.id}/external_system/${start}/${end}/send_email/${email}`,
        { params: normalizedParams }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async sendAuditReport({ rootState }, { ...params }) {
    const { currentProject } = rootState.applicationState
    const normalizedParams = prepareFilterWithEmployeeLegalEntities({
      filter: params,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_ids'
    })

    try {
      const { data } = await apiClient.post('/api/project/audit_report/send_email', {
        ...normalizedParams,
        project_id: currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async sendPPDAudit({ rootState }, { email, filters }) {
    const { currentProject } = rootState.applicationState

    try {
      const { data } = await apiClient.get(`/api/report/project/${currentProject.id}/pbj_export/send_email/${email}`, {
        params: {
          ...filters
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.message
    } catch (error) {
      throw error.message
    }
  },

  async downloadCrossSystemCompliance({ rootState }, { start, end }) {
    const { id } = rootState.applicationState.currentProject

    try {
      const { data } = await apiClient.get(`/api/report/project/${id}/cross_site_compliance/${start}/${end}/download`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async sendCrossSystemCompliance({ rootState }, { start, end, email }) {
    const { id } = rootState.applicationState.currentProject

    try {
      const { data } = await apiClient.get(
        `/api/report/project/${id}/cross_site_compliance/${start}/${end}/send_email/${email}`
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async generatePBJReport(_, payload) {
    try {
      const { data } = await apiClient.post('/api/tc_generate_pbj_report', {
        ...payload,
        ignore_auths_issues: true
      })

      assertNoApiError(data)

      return data
    } catch (error) {
      throw error.message
    }
  },

  async validatePayPeriod({ rootState }, { start, end }) {
    try {
      const { data } = await apiClient.post('/api/payroll/pay_period/validate_pay_period', {
        project_id: rootState.applicationState.currentProject.id,
        start,
        end
      })

      assertNoApiError(data)

      return data.pay_periods ?? []
    } catch (error) {
      throw error.message
    }
  },

  async generatePBJReportExport(_, payload) {
    try {
      const { data } = await apiClient.post(`/api/tc_generate_pbj_report_export`, {
        ...payload,
        ignore_auths_issues: true
      })

      assertNoApiError(data)

      return data
    } catch (error) {
      throw error.message
    }
  },

  async generatePBJReportPPD(_, payload) {
    try {
      const { data } = await apiClient.post('/api/tc_generate_pbj_report_ppd', {
        ...payload,
        ignore_auths_issues: true
      })

      assertNoApiError(data)

      return data
    } catch (error) {
      throw error.message
    }
  },

  async generateDocumentationCompliance({ rootState }, payload) {
    const project_id = rootState.applicationState.currentProject.id
    const scope = prepareFilterWithEmployeeLegalEntities({
      filter: payload.scope,
      paymentTypeKey: 'payment_types',
      legalEntityKey: 'legal_entities'
    })

    try {
      const { data } = await apiClient.post('/api/custom_document_compliance', {
        ...payload,
        scope,
        project_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async generateAssociateDocumentationCompliance({ rootState }, payload) {
    const project_id = rootState.applicationState.currentProject.id
    const filters = prepareFilterWithEmployeeLegalEntities({
      filter: payload.filters,
      paymentTypeKey: 'payment_types',
      legalEntityKey: 'legal_entity_ids'
    })

    try {
      const { data } = await apiClient.post('/api/associate_document_compliance', {
        ...payload,
        filters,
        project_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async getAllDocumentation({ rootState }, { name, cancelPreviousRequests = true }) {
    try {
      const { data } = await apiClient.get('/api/documentation/search', {
        params: {
          name,
          project_id: rootState.applicationState.currentProject.id
        },
        cancelPreviousRequests
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.documents
    } catch (error) {
      throw error.message
    }
  },

  async getTimeAttendanceDetailReport(_, { filters, type }) {
    const headerContentOptions = [
      {
        key: 'reportGenerationDate',
        title: 'Report Generation Date',
        checked: true
      },
      { key: 'role', title: 'Position', checked: true },
      { key: 'status', title: 'Status', checked: true }
    ]

    const reportContentOptions = [
      { key: 'role', title: 'Position', checked: true },
      { key: 'date', title: 'Date', checked: true },
      { key: 'start', title: 'Start', checked: true },
      { key: 'end', title: 'End', checked: true },
      { key: 'signedHours', title: 'Regular', checked: true },
      { key: 'firstOverTime', title: 'OT 1', checked: true },
      { key: 'secondOverTime', title: 'OT 2', checked: true },
      { key: 'dailyTotalHours', title: 'Daily Total', checked: true }
    ]

    try {
      const { data } = await apiClient.post(
        type === 'PDF' ? '/api/tc_get_time_attendance_detail_report' : '/api/tc_send_shifts_report',
        {
          ...filters,
          header_content_options: headerContentOptions,
          report_content_options: reportContentOptions
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.report_url
    } catch (error) {
      throw error.message
    }
  },

  async generateAssociateHighRisk({ rootState }, payload) {
    const project_id = rootState.applicationState.currentProject.id
    const filters = prepareFilterWithEmployeeLegalEntities({
      filter: payload.filters,
      paymentTypeKey: 'payment_types',
      legalEntityKey: 'legal_entity_ids'
    })

    try {
      const { data } = await apiClient.post('/api/report/high_risk', {
        ...payload,
        filters,
        project_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async downloadTotalHours({ rootState }, payload) {
    const project_id = rootState.applicationState.currentProject.id
    const filters = prepareFilterWithEmployeeLegalEntities({
      filter: payload,
      paymentTypeKey: 'payment_type',
      legalEntityKey: 'legal_entity_id'
    })

    try {
      const { data } = await apiClient.post('/api/total_hours_report', {
        filters: { ...filters, project_id }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  },

  async getReportsList() {
    try {
      const { data } = await apiClient.get('/api/epeople_reports')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.report
    } catch (error) {
      throw error.message
    }
  },

  async setReportFilters({ commit }, payload) {
    commit('SET_REPORT_FILTERS', payload)
  },

  async getReportFilters({ commit }, { report_service_name }) {
    try {
      const { data } = await apiClient.get(`/api/epeople_reports/${report_service_name}/filters`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_REPORT_FILTERS', data.filters)
    } catch (error) {
      throw error.message
    }
  },

  async getReportValues({ rootState }, { endpoint_url, filters }) {
    try {
      const { data } = await apiClient.get(`/api/epeople_reports/filter/${endpoint_url}`, {
        params: { ...filters }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.items
    } catch (error) {
      throw error.message
    }
  },

  async getReport(_, { report_service_name, filters, format = 'json' }) {
    try {
      const { data } = await apiClient.post(
        `/api/epeople_reports/${report_service_name}/get_value`,
        {
          filters,
          format
        },
        {
          cancelPreviousRequests: true
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.items
    } catch (error) {
      throw error.message
    }
  },

  async exportReport(_, { report_service_name, filters, format = 'json' }) {
    try {
      const { data } = await apiClient.post(`/api/epeople_reports/${report_service_name}/get_value`, {
        filters,
        format
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.url
    } catch (error) {
      throw error.message
    }
  }
}
